import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/components/Home";
import AiEngineering from "@/pages/AiEngineering";
import CaseStudy from "@/pages/CaseStudy";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <div className="App" data-testid="portfolio-app">
          <div className="noise-overlay" aria-hidden="true" />
          <ScrollToTop />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ai-engineering" element={<AiEngineering />} />
            <Route path="/projects/:slug" element={<CaseStudy />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-right" />
        </div>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
